'use client'

import * as React from 'react'
import { useIsMobile } from 'store/server-context/device'

const NO_SUPPORT_LANDSCAPE = '__no-support-landscape__'

const createElement = () => {
  const el = document.createElement('p')
  el.className = `${NO_SUPPORT_LANDSCAPE} fixed left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 transform items-center justify-center whitespace-nowrap text-lg`

  el.textContent = 'Please keep your phone upright for the best experience'
  return el
}

const NotSupportedLandscape = () => {
  const isMobile = useIsMobile()

  React.useEffect(() => {
    if (!isMobile) {
      return
    }
    const matchMedia = window.matchMedia('(orientation: landscape)')
    let el: HTMLElement | null = null
    const listener = (e: MediaQueryListEvent) => {
      if (e.matches) {
        document.querySelectorAll('body > div').forEach(el => {
          el.classList.add('!hidden')
        })
        el = createElement()
        document.body.appendChild(el)
      } else {
        el?.remove()
        document.querySelectorAll('body > div').forEach(el => {
          el.classList.remove('!hidden')
        })
      }
    }

    matchMedia.addEventListener('change', listener)

    return () => {
      matchMedia.removeEventListener('change', listener)
    }
  }, [isMobile])

  return null
}

export default NotSupportedLandscape
